import Cookies from "js-cookie";

export const checkAuth = (sessionId)=> {
    if (Cookies.get('sessionAuth')) {
        let cookieData = JSON.parse(Cookies.get('sessionAuth'));
        return cookieData.indexOf(sessionId) > -1
    }else{
        return false
    }
}